import { useState } from "react";
import { CreditCard, ArrowRight, Loader2 } from "lucide-react";
import { apiClient } from "../services/ApiServices";
import logo from "../assets/logo.png";

export function AccVer({ onSubmit }) {
  const [accountNumber, setAccountNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!accountNumber.trim()) {
      setError("Please enter an account number");
      return;
    }
    

    setLoading(true);
    try {
    const response = await apiClient.post(`/customer/verification/initiate`,{accountNumber: accountNumber});
     
      const data = response.data;
      console.log(accountNumber, data);
      onSubmit(accountNumber, data);
    } catch (err) {
      
      if (err.response  && err.response.status !== 500) {
        console.log(err.response.data.message);
        setError(err.response.data.error);
      } else {
      setError("Failed to fetch customer data. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
   <div className="bg-gradient-to-br from-gray-50 to-gray-100 min-h-[100dvh] flex items-center justify-center px-4 py-8 sm:px-6 sm:py-12">
  <div className="w-full max-w-2xl">
    
    {/* Header Card */}
    <div className="bg-gradient-to-r from-[#472f92] to-[#6a4bc5] shadow-xl rounded-2xl p-6 sm:p-8 text-white mb-6 sm:mb-8 transition-all">
      <div className="flex flex-col items-center text-center">

        {/* Logo */}
        <div className="flex items-center justify-center mb-4">
          <img
            src={logo}
            alt="Fayda Logo"
            className="h-12 sm:h-16 object-contain"
          />
        </div>

        <div className="h-1 w-20 sm:w-24 bg-gradient-to-r from-[#e4aa24] to-[#f2c94c] rounded-full mb-4"></div>

        <p className="text-purple-100 text-base sm:text-lg max-w-md">
          Please enter your account number to begin the verification process
        </p>

        {/* Decorative dots */}
        <div className="flex mt-5 space-x-2">
          <div className="w-2.5 h-2.5 rounded-full bg-[#e4aa24]" />
          <div className="w-2.5 h-2.5 rounded-full bg-white/50" />
          <div className="w-2.5 h-2.5 rounded-full bg-white/70" />
          <div className="w-2.5 h-2.5 rounded-full bg-white/70" />
       
        </div>
      </div>
    </div>

    {/* Form Card */}
    <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-lg">
      <h2 className="text-2xl sm:text-3xl font-bold text-center text-slate-800 mb-4">
        Enter Account Number
      </h2>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <input
            type="text"
            value={accountNumber}
            onChange={(e) => {const sanitized = e.target.value.replace(/[^0-9]/g, ''); setAccountNumber(sanitized);}}
            placeholder="Enter your account number"
            className="w-full px-4 py-3 sm:py-4 border-2 border-slate-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none text-base sm:text-lg"
            disabled={loading}
            inputMode="numeric"
          />
          {error && (
            <p className="mt-2 text-sm text-red-600">{error}</p>
          )}
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-gradient-to-r from-[#472f92] to-[#e4aa24] text-white py-3.5 sm:py-4 rounded-lg font-semibold transition-all shadow-md disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {loading ? (
            <>
              <Loader2 className="w-5 h-5 animate-spin" />
              Fetching Customer Data...
            </>
          ) : (
            <>
              Continue
              <ArrowRight className="w-5 h-5" />
            </>
          )}
        </button>
      </form>
      
    </div>
    
  </div>

</div>

  );
}
